import { useAuth } from './AuthProvider';

/**
 * Returns true if the authenticated user has the given scope.
 */
export function useScope(scope: string): boolean {
  const { scopes } = useAuth();
  return scopes.has(scope);
}

/**
 * Returns the full set of scopes for the current user.
 */
export function useScopeSet(): ReadonlySet<string> {
  const { scopes } = useAuth();
  return scopes;
}

/**
 * Returns true if the authenticated user holds at least one of the provided
 * scopes. Useful for OR-gating a nav group visible to multiple admin roles.
 *
 * Built on {@link useScopeSet} so it reads from the same Auth context and
 * does not cause additional re-renders.
 *
 * @example
 * const canSeeAdminGroup = useAnyScope(['users:admin', 'entitlements:admin']);
 */
export function useAnyScope(scopes: string[]): boolean {
  const scopeSet = useScopeSet();
  return scopes.some((s) => scopeSet.has(s));
}
